import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import sortBy from 'lodash.sortby';
import Button from '@saucelabs/sl-component-buttons';
import { Modal } from '@saucelabs/sl-component-overlay';
import modalConnect from '@saucelabs/sl-container-modal';
import { Loader } from '@saucelabs/sl-component-loader';

import ChangeLanguageList from './ChangeLanguageList';
import * as actions from './../../actions';
import Styles from './ChangeLanguageModal.styles';

class ChangeLanguageModal extends Component {
  componentDidUpdate(prevProps) {
    const { fetchLanguages, show } = this.props;

    if (show && prevProps.show !== show) {
      fetchLanguages();
    }
  }

  handleLanguageListItemClick = (language) => {
    const { onHide, setLanguage } = this.props;

    setLanguage(language).then(onHide);
  }

  render() {
    const {
      languages,
      onHide,
      show,
    } = this.props;

    const sortedLanguages = sortBy(Object.values(languages.items), 'label');

    return (
      <Modal
        dialogClassName={Styles.default}
        onHide={onHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Change Language</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Loader show={languages.loading}>
            <ChangeLanguageList
              items={sortedLanguages}
              onClick={this.handleLanguageListItemClick}
            />
          </Loader>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="default"
            material
            onClick={onHide}
            size="sm"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ChangeLanguageModal.propTypes = {
  fetchLanguages: PropTypes.func.isRequired,
  languages: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
  setLanguage: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ apps: { manual } }) => ({
  languages: manual.session.get('languages'),
});

const mapDispatchToProps = {
  fetchLanguages: actions.fetchMobileDeviceLanguages,
  setLanguage: actions.setMobileDeviceLanguage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(modalConnect('changeLanguageModal', ChangeLanguageModal));

export {
  ChangeLanguageModal,
};
